import { space } from '@synoptic/ui-kit/tokens.js';
import { style } from '@vanilla-extract/css';

export const confirmModalActions = style({
  display: 'flex',
  marginTop: space.s32,
  gap: space.s16,
  justifyContent: 'end',
});
